import { createGlobalStyle } from "styled-components";

const isDev = process.env.NODE_ENV === "development";

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.colors.text};
    background: ${({ theme }) => theme.colors.background};
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    min-height: 100vh;
    transition: background 0.25s ease, color 0.25s ease;

    -webkit-touch-callout: none;

    -webkit-user-select: ${isDev ? "auto" : "none"};
    -moz-user-select: ${isDev ? "auto" : "none"};
    -ms-user-select: ${isDev ? "auto" : "none"};
    user-select: ${isDev ? "auto" : "none"};
  }

  h1,h2,h3,h4,h5,h6 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    color: ${({ theme }) => theme.colors.heading};
  }

  /* Images */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Links */
  a {
    text-decoration: none;
    color: inherit;
    transition: color 0.25s ease;
  }

  /* Buttons */
  button {
    font-family: inherit;
    border: none;
    background: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: all 0.25s ease;
  }

  /* Forms */
  input, textarea, select {
    font-family: inherit;
    outline: none;
    border: none;
    background: none;
    font-size: 16px;
  }

  /* iOS input zoom fix */
  input, select, textarea {
    font-size: 16px;
  }

  /* Remove autofill color */
  input:-webkit-autofill {
    box-shadow: 0 0 0 1000px transparent inset;
  }

  /* Improve touch behavior */
  button, a {
    touch-action: manipulation;
  }

  /* Selection */
  ::selection {
    background: ${({ theme }) => theme.colors.primary};
    color: white;
  }

  /* Optional global utility classes for quick layout */
  .text-center { text-align: center; }
  .text-right { text-align: right; }
  .text-left { text-align: left; }
  .uppercase { text-transform: uppercase; }
  .capitalize { text-transform: capitalize; }

  /* Scrollbar nur wenn wirklich nötig – keine Corner-Reservierung */
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Nur Thumb stylen */
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.gray500};
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Wichtig: verhindert das weiße Quadrat */
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;